<script>
    import ImageHeader from "./ImageHeader.svelte";
    import Unsubscribe from "./Unsubscribe.svelte";
    import SocialMediaControl from "./SocialMediaControl.svelte";
    import BlockGlobal from "./BlockGlobal.svelte";
    import { M } from '../../external';

    export let data, onChange;
</script>
<ImageHeader bind:data={data} disable={['align', 'blockGlobal']} onChange={onChange} label="{M.LOGO}"/>
<SocialMediaControl bind:data={data}/>
<Unsubscribe bind:data={data} disable={['align', 'blockGlobal', 'brandingPosition']} isCollapsable={true} isCollapsed={true}/>
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>
